import React from 'react'
import { Box, Icon, Text, VStack } from '@chakra-ui/react'
import type { IconType } from 'react-icons'

interface ChoiceCardProps {
  label: string
  icon: IconType
  colorScheme: 'green' | 'red'
  selected: boolean
  onSelect: () => void
}

const ChoiceCard: React.FC<ChoiceCardProps> = ({ label, icon, colorScheme, selected, onSelect }) => (
  <Box
    as="button"
    type="button"
    role="radio"
    aria-checked={selected}
    flex="1"
    cursor="pointer"
    border="2px solid"
    borderColor={selected ? `${colorScheme}.400` : 'gray.200'}
    borderRadius="lg"
    bg={selected ? `${colorScheme}.50` : 'white'}
    p={{ base: 3, md: 4 }}
    transition="all 0.2s"
    _hover={{ borderColor: `${colorScheme}.400`, transform: 'translateY(-2px)', shadow: 'md' }}
    onClick={onSelect}
  >
    <VStack spacing={2}>
      <Icon as={icon} w={{ base: 6, md: 8 }} h={{ base: 6, md: 8 }} color={selected ? `${colorScheme}.500` : 'gray.400'}/>
      <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'lg' }} lineHeight="short" color={selected ? `${colorScheme}.600` : 'gray.700'}>
        {label}
      </Text>
    </VStack>
  </Box>
)

export default ChoiceCard
